(() => {
  if (window.BlumaeBundleCartProtectionV2) return;
  window.BlumaeBundleCartProtectionV2 = true;

  const routes = () => ({
    cart: window.FoxThemeSettings?.routes?.cart_url || '/cart',
    update: window.FoxThemeSettings?.routes?.cart_update_url || '/cart/update.js'
  });

  const sectionsForDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
    return Array.from(new Set(drawer.getSectionsToRender(true).map((section) => section.id)));
  };

  const publishCart = (cart, sections) => {
    if (sections) cart.sections = sections;
    if (window.FoxThemeCartHelpers) window.FoxThemeCartHelpers.updateCartCount(cart.item_count);
    if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, cart);
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
  };

  const confirmBundleRemoval = ({ message, confirmLabel, cancelLabel }) => new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.className = 'blumae-bundle-confirm';
    overlay.innerHTML = `
      <div class="blumae-bundle-confirm__dialog" role="alertdialog" aria-modal="true" aria-labelledby="BlumaeBundleConfirmTitle">
        <strong id="BlumaeBundleConfirmTitle" class="blumae-bundle-confirm__title"></strong>
        <div class="blumae-bundle-confirm__actions">
          <button type="button" class="blumae-bundle-confirm__cancel"></button>
          <button type="button" class="blumae-bundle-confirm__remove"></button>
        </div>
      </div>`;
    overlay.querySelector('.blumae-bundle-confirm__title').textContent = message;
    overlay.querySelector('.blumae-bundle-confirm__cancel').textContent = cancelLabel;
    overlay.querySelector('.blumae-bundle-confirm__remove').textContent = confirmLabel;
    document.body.appendChild(overlay);

    const finish = (answer) => {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
      resolve(answer);
    };
    const onKeydown = (event) => {
      if (event.key === 'Escape') finish(false);
    };
    document.addEventListener('keydown', onKeydown);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target.closest('.blumae-bundle-confirm__cancel')) finish(false);
      if (event.target.closest('.blumae-bundle-confirm__remove')) finish(true);
    });
    overlay.querySelector('.blumae-bundle-confirm__cancel').focus();
  });

  const removeBundle = async ({ group, trigger, message, confirmLabel, cancelLabel, errorMessage }) => {
    const confirmed = await confirmBundleRemoval({ message, confirmLabel, cancelLabel });
    if (!confirmed) return;

    if (trigger) {
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
    }

    try {
      const route = routes();
      const cart = await fetch(`${route.cart}.js`).then((response) => response.json());
      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties?._blumae_bundle_group === group) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;

      const sections = sectionsForDrawer();
      const response = await fetch(route.update, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
      });
      const updated = await response.json();
      if (!response.ok || updated.status) throw new Error(updated.description || updated.message || 'Cart update error');
      publishCart(updated, updated.sections);
    } catch (error) {
      console.error(error);
      if (trigger) {
        trigger.disabled = false;
        trigger.removeAttribute('aria-busy');
      }
      const language = (document.documentElement.lang || 'fr').slice(0, 2);
      const fallback = {
        fr: 'Impossible de modifier le panier. Veuillez réessayer.',
        en: 'The cart could not be updated. Please try again.',
        de: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
        es: 'No se pudo actualizar el carrito. Inténtalo de nuevo.'
      };
      const notice = document.createElement('div');
      notice.className = 'blumae-bundle-toast';
      notice.textContent = errorMessage || fallback[language] || fallback.fr;
      document.body.appendChild(notice);
      window.setTimeout(() => notice.remove(), 3500);
    }
  };

  document.addEventListener('click', (event) => {
    const bundleButton = event.target.closest('[data-blumae-remove-bundle]');
    const shadeButton = event.target.closest('.blumae-cart-bundle-item cart-remove-button button');
    if (!bundleButton && !shadeButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const item = shadeButton?.closest('.blumae-cart-bundle-item');
    const group = bundleButton?.dataset.blumaeRemoveBundle || item?.dataset.blumaeBundleGroup;
    const summaryButton = bundleButton || document.querySelector(`[data-blumae-remove-bundle="${CSS.escape(group || '')}"]`);
    if (!group || !summaryButton) return;

    removeBundle({
      group,
      trigger: summaryButton,
      message: shadeButton ? item.dataset.blumaeRemoveWarning : summaryButton.dataset.confirm,
      confirmLabel: summaryButton.dataset.confirmLabel,
      cancelLabel: summaryButton.dataset.cancelLabel,
      errorMessage: summaryButton.dataset.error
    });
  }, true);
})();
